module.exports = __webpack_public_path__ + "school/img/shizi_zhuanqu3ji.6b5723b9.jpg";